import { Pipe, PipeTransform } from "@angular/core";
import linkifyStr from 'linkifyjs/string';
@Pipe({name:'linkifystr'})
export class LinkifystrPipe implements PipeTransform{
    transform(str:string):string{
        return str? linkifyStr(str, {target:'_system'}):str;
    }
}


// WEBPACK FOOTER //
// C:/Users/USUARIO/Documents/Platzi/cursos__2017/Angular_4_PROFESIONAL/proyectos/platzisquare2/src/app/pipes/linkifystr.pipe.ts